import { TemplateRef } from '@angular/core';

export interface TabTemplate {
  header: string;
  template: TemplateRef<any>;
}
